import buildCreateEntityMutation from './build-create-entity-mutation';
import buildUpdateEntityMutation from './build-update-entity-mutation';

export { buildCreateEntityMutation, buildUpdateEntityMutation };
